<template>
  <a
    :href="notification.link"
    class="tw-p-4 tw-flex tw-gap-2"
    @click.prevent="openNotificationDetails"
  >
    <div class="tw-flex-shrink-0">
      <icon-general-notification-m
        class="tw-w-6 tw-h-auto"
        :class="notification.seen ? 'tw-text-gray-dark dark:tw-text-dm-gray-dark' : 'tw-text-primary dark:tw-text-dm-primary'"
      />
    </div>
    <div>
      <div
        class="tw-font-bold tw-leading-5 tw-tracking-wider tw-mb-1"
        :class="notification.seen ? 'tw-text-gray-dark dark:tw-text-dm-gray-dark' : 'tw-text-primary dark:tw-text-dm-primary'"
      >
        {{ $capitalize(notification.title) }}
      </div>
      <div class="tw-text-xs tw-leading-[14px] tw-text-gray-dark tw-mb-2">
        {{ $dayjs(notification.date_created, 'DD.MM.YYYY HH:mm').format('DD. MM. YYYY HH:mm') }}
      </div>
      <div
        class="tw-text-base tw-leading-5 tw-font-medium"
        :class="notification.seen ? 'tw-text-gray-dark dark:tw-text-dm-gray-dark' : 'tw-text-dark dark:tw-text-dm-dark'"
      >
        {{ notification.description }}
      </div>
    </div>
  </a>
</template>

<script>
export default {
  props: {
    notification: {
      type: Object,
      required: true,
    },
  },

  methods: {
    openNotificationDetails() {
      this.$router.push({
        path: this.notification.link,
        query: { fid: this.notification.recipient_id },
      });
      if (!this.notification.seen) {
        this.$store.dispatch('v2/shared/notifications/updateNotification', { notificationId: this.notification.id, payload: { seen: true } });
      }
    },
  },
};
</script>
